// src/contexts/SettingsContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { subscribeSettings } from "../services/userService";

export const DEFAULT_SETTINGS = {
  depositMin:              50,
  depositMax:              500,
  depositFixed:            100,
  commission:              15,
  searchLimitMinutes:      60,
  depositLimitMinutes:     30,
  depositReviewLimitHours: 24,
  instaPayNumber:          "",
  instaPayName:            "رايدو",
  instaPayLink:            "",   // ← رابط الدفع المخصص (من لوحة المدير)
  supportPhone:            "",
};

const Ctx = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    return subscribeSettings(data => setSettings(prev => ({ ...prev, ...data })));
  }, []);
  return <Ctx.Provider value={settings}>{children}</Ctx.Provider>;
}

export function useSettings() {
  return useContext(Ctx);
}
